export const getCurrentLanguageFromPath = (fallbackLanguage = 'en') => {
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname;
    const match = pathname.match(/^\/([a-z]{2})(\/|$)/);
    return match ? match[1] : fallbackLanguage;
  }
  return fallbackLanguage;
};

export const generateRefParam = (targetLanguage = null) => {
  const currentLang = getCurrentLanguageFromPath();

  switch(currentLang) {
    case 'fr':
      return '?ref=fr';

    case 'ja':
      return '?ref=ja';

    case 'ru':
      return '?ref=ru';

    case 'tr':
      return '?ref=tr';

    case 'br':
      return '?ref=br';

    case 'es':
      return '?ref=es';

    case 'de':
      return '?ref=de';

    case 'it':
      return '?ref=it';

    case 'pt':
      return '?ref=pt';

    case 'zh':
      return '?ref=zh';

    case 'ko':
      return '?ref=kr';

    case 'hi':
      return '?ref=in';

    case 'en':
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingRef = urlParams.get('ref');
        if (existingRef && targetLanguage && existingRef !== targetLanguage) {
          return `?ref=${existingRef}`;
        }
      }
      return '?ref=en';

    case 'ar':
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingRef = urlParams.get('ref');
        if (existingRef && targetLanguage && existingRef !== targetLanguage) {
          return `?ref=${existingRef}`;
        }
      }
      return '?ref=ar';

    case 'us':
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingRef = urlParams.get('ref');
        if (existingRef && targetLanguage && existingRef !== targetLanguage) {
          return `?ref=${existingRef}`;
        }
      }
      return '?ref=us';

      case 'au':
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingRef = urlParams.get('ref');
        if (existingRef && targetLanguage && existingRef !== targetLanguage) {
          return `?ref=${existingRef}`;
        }
      }
      return '?ref=au';

      case 'eg':
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingRef = urlParams.get('ref');
        if (existingRef && targetLanguage && existingRef !== targetLanguage) {
          return `?ref=${existingRef}`;
        }
      }
      return '?ref=eg';

      case 'jo':
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const existingRef = urlParams.get('ref');
        if (existingRef && targetLanguage && existingRef !== targetLanguage) {
          return `?ref=${existingRef}`;
        }
      }
      return '?ref=jo';

    default:
      return `?ref=${currentLang}`;
  }
};

export const getExistingRefParam = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('ref');
  }
  return null;
};

export const buildLanguageSwitchUrl = (targetUrl, targetLanguage) => {
  const cleanUrl = targetUrl.replace(/\/$/, '');
  const refParam = generateRefParam(targetLanguage);
  return `${cleanUrl}${refParam}`;
};
